<template>
  <div class="badgeContainer pl-3 pr-4 py-2">
    <p class="mb-0">{{ text }}</p>
    <div class="numberBadge d-flex justify-content-center align-items-center" v-if="badge">
      <p class="mb-0">{{ badge }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BadgeWithText",
  props: {
    text: String,
    badge: String,
  },
};
</script>

<style lang="scss" scoped>
.badgeContainer {
  background-color: $color-orange;
  color: $color-white;
  border-bottom-left-radius: 4px;
}

.numberBadge {
  position: absolute;
  z-index: 10;
  top: -10px;
  right: -10px;
  width: 30px;
  height: 30px;
  background-color: $color-light;
  border: 2px solid $color-orange;
  border-radius: 50%;
  color: $color-orange;
}
</style>
